export default "__VITE_ASSET__ClKbmDLV__"